/* 🤖 this file was generated by svg-to-ts */
export const matIconCallMissed: {
  name: 'call-missed';
  data: string;
} = {
  name: 'call-missed',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19.59 7 12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9L19.59 7z"/></svg>`
};
